import { render, staticRenderFns } from "./MerchantAccountCenter.vue?vue&type=template&id=6aadacea&scoped=true"
import script from "./MerchantAccountCenter.vue?vue&type=script&lang=js"
export * from "./MerchantAccountCenter.vue?vue&type=script&lang=js"
import style0 from "./MerchantAccountCenter.vue?vue&type=style&index=0&id=6aadacea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadacea",
  null
  
)

export default component.exports